import { AxiosResponse } from 'axios'
import { inject, InjectionKey, ref } from 'vue'
import { Room } from '../../../libs/models'
import { useApi } from './api'
import polling from '../libs/polling'

export interface RoomsStore {
  readonly value: Room[] | null
  remove: (ids: number[]) => void
}
export const generateRoomsStore = (): RoomsStore => {
  const rooms = ref<Room[] | null>(null)
  const api = useApi()
  const fetch = (): Promise<Room[]> => {
    return api.get('/rooms').then(({ data }: AxiosResponse<Room[]>) => {
      rooms.value = data
      return data
    })
  }
  const remove = (ids: number[]) => {
    rooms.value = rooms.value?.filter(room => !ids.includes(room.id)) ?? []
    return api.post('/rooms/history/delete', { room_ids: ids })
  }
  polling((next: Function) => {
    fetch().then(() => {
      next(60000)
    })
  })
  return {
    get value () {
      return rooms.value
    },
    remove
  }
}
export const roomsStoreKey: InjectionKey<RoomsStore> = Symbol()
export const useRoomsStore = (): RoomsStore => {
  const roomsStore = inject(roomsStoreKey)
  if (!roomsStore) throw Error('Could not inject roomsStore')
  return roomsStore
}
